var map = {
	"./ion-action-sheet.entry.js": [
		1971,
		1971
	],
	"./ion-alert.entry.js": [
		2325,
		2325
	],
	"./ion-app_8.entry.js": [
		91753,
		1753
	],
	"./ion-avatar_3.entry.js": [
		72368,
		2368
	],
	"./ion-back-button.entry.js": [
		8864,
		8864
	],
	"./ion-backdrop.entry.js": [
		52585,
		2585
	],
	"./ion-button_2.entry.js": [
		85659,
		5659
	],
	"./ion-card_5.entry.js": [
		44209,
		4209
	],
	"./ion-checkbox.entry.js": [
		52016,
		2016
	],
	"./ion-chip.entry.js": [
		57001,
		7001
	],
	"./ion-col_3.entry.js": [
		86223,
		6223
	],
	"./ion-datetime_3.entry.js": [
		59118,
		9118
	],
	"./ion-fab_3.entry.js": [
		89180,
		9180
	],
	"./ion-img.entry.js": [
		25928,
		5928
	],
	"./ion-infinite-scroll_2.entry.js": [
		23782,
		3782
	],
	"./ion-input.entry.js": [
		83983,
		3983
	],
	"./ion-item-option_3.entry.js": [
		89662,
		8029
	],
	"./ion-item_8.entry.js": [
		3051,
		3051
	],
	"./ion-loading.entry.js": [
		9662,
		9662
	],
	"./ion-menu_3.entry.js": [
		69978,
		9978
	],
	"./ion-modal.entry.js": [
		14354,
		4354
	],
	"./ion-nav_2.entry.js": [
		47998,
		7998
	],
	"./ion-popover.entry.js": [
		30078,
		78
	],
	"./ion-progress-bar.entry.js": [
		30839,
		839
	],
	"./ion-radio_2.entry.js": [
		77782,
		7782
	],
	"./ion-range.entry.js": [
		25021,
		5021
	],
	"./ion-refresher_2.entry.js": [
		73033,
		3033
	],
	"./ion-reorder_2.entry.js": [
		30920,
		3098
	],
	"./ion-ripple-effect.entry.js": [
		88140,
		8140
	],
	"./ion-route_4.entry.js": [
		38321,
		8321
	],
	"./ion-searchbar.entry.js": [
		88666,
		8666
	],
	"./ion-segment_2.entry.js": [
		34496,
		4496
	],
	"./ion-select_3.entry.js": [
		91820,
		1820
	],
	"./ion-slide_2.entry.js": [
		12049,
		2049
	],
	"./ion-spinner.entry.js": [
		26417,
		6417
	],
	"./ion-split-pane.entry.js": [
		54083,
		4083
	],
	"./ion-tab-bar_2.entry.js": [
		29986,
		9986
	],
	"./ion-tab_2.entry.js": [
		9737,
		9737
	],
	"./ion-text.entry.js": [
		74365,
		4365
	],
	"./ion-textarea.entry.js": [
		16906,
		6906
	],
	"./ion-toast.entry.js": [
		19936,
		9936
	],
	"./ion-toggle.entry.js": [
		73068,
		3068
	],
	"./ion-virtual-scroll.entry.js": [
		44859,
		4859
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 55390;
module.exports = webpackAsyncContext;